"use es6";

/**
 * Note: This file is autogenerated using "resources/gen-version.js" script and
 * automatically updated by "yarn version" command.
 */

/**
 * A string containing the version of the GraphQL.js library
 */
export var version = '14.6.0';
/**
 * An object containing the components of the GraphQL.js version string
 */

export var versionInfo = Object.freeze({
  major: 14,
  minor: 6,
  patch: 0,
  preReleaseTag: null
});